import React, { useRef } from 'react';
import useWaBooleanProps from './useWaBooleanProps';

// Thin wrapper over <wa-button> that routes its boolean props (disabled/loading/pill/caret)
// through useWaBooleanProps so they are set as element *properties*, never as JSX attributes.
// See useWaBooleanProps.js for why binding a boolean directly on a wa-* element is a bug under
// React 18. Non-boolean props (variant, size, appearance, href, type, onClick, slot, style,
// className, children, ...) pass straight through to <wa-button>.
function WaButton({ disabled, loading, pill, caret, children, ...rest }) {
	const ref = useRef(null);
	useWaBooleanProps(ref, { disabled, loading, pill, caret });

	return (
		<wa-button ref={ref} {...rest}>
			{children}
		</wa-button>
	);
}

export default WaButton;
